import gql from 'graphql-tag';

export const updateContactList = gql`
  mutation updateContactList($id: ID!, $input: UpdateContactListInput) {
    updateContactList(id: $id, input: $input) {
      id
      MemberCodes {
        id
        code
      }
      BusinessUnits {
        id
        name
      }
      name
      ContactListUpdaters {
        id
        ContactId
      }
      ContactListMembers {
        id
        ContactId
        order
        isScheduled
        Contact {
          id
          firstName
          lastName
          nickName
          inactiveAdAccount
          afterHoursPhoneNumber
          speedDial
          version
          Company {
            id
            name
            abbreviation
            version
          }
          adAccountName
          JobRole {
            id
            name
            version
          }
          ReportsTo {
            id
            firstName
            lastName
            ReportsTo {
              id
              firstName
              lastName
              ReportsTo {
                id
                firstName
                lastName
              }
            }
            version
          }
          businessMobile
          businessPhone
          home
          other
          personalMobile
          adAccountName
          city
          Availabilities {
            id
            ContactId
            start
            end
            version
          }
        }
      }
      Facilities {
        id
        ContactListId
        facilityName
        facilityUid
        Locations {
          id
          state
          county
          township
        }
      }
      ManagementFacilities {
        id
        ContactListId
        facilityName
        facilityUid
        Locations {
          id
          state
          county
          township
        }
      }
      AdditionalResourceListFacilities {
        id
        ContactListId
        facilityName
        facilityUid
        Locations {
          id
          state
          county
          township
        }
      }
      AdditionalResourceListType {
        id
        name
        enabled
      }
    }
  }
`;
